import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
// import * as moment from 'moment';
import { FormControl, FormGroup } from '@angular/forms';
import { formatToCurrency } from '@console/shared/utils/formatter';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  takeUntil,
  tap,
} from 'rxjs/operators';
// import { PageEvent } from '../../../../../shared/src/lib/interface';
import {
  ConsoleRouterService,
  TRANSACTION_STATUS,
  WALLET_TRANSACTION_STATUS,
} from '../../../../../shared/src/public-api';
import {
  WalletTxnDetailsModel,
  WalletTxnsModel,
} from '../services/transactions.model';

import { PageEvent } from '@angular/material/paginator';
import {
  exportAndDownload,
  fileNameFormatter,
} from 'projects/_shared/csv-downloader/csv-downloader';
import { Subject } from 'rxjs';
import {
  TransactionListState,
  TransactionListStateService,
} from '../transactions-list/transaction-state';
import { MatTableDataSource } from '@angular/material/table';
import { MatMultiSort } from 'ngx-mat-multi-sort';
import { extractSearchParams } from '@console/shared/utils/extractSearchParams';
import { MerchantsModel } from '../../merchants/merchants.interface';
import { AuthProfileStateService } from '@console/authentication/profile-state';
import {
  MerchantListState,
  MerchantListStateService,
} from '../../merchants/merchant-list/merchant-list.state';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'kt-transactions-table',
  templateUrl: './transactions-table.component.html',
  styleUrls: ['./transactions-table.component.scss'],
  providers: [MerchantListStateService],
})
export class TransactionsTableComponent implements OnInit, OnDestroy {
  @Input() userId;

  /**
   * total amount of data being returned
   */
  count = 0;

  /**
   * loading controller
   */
  loading = false;

  /**
   * Error message for the table
   */
  error;

  /**
   * Query emitter to parent component
   */
  @Output() query = new EventEmitter<object>();

  /**
   * emit query selected from the table
   */
  @Output() transaction = new EventEmitter<WalletTxnsModel>();

  @Output() download = new EventEmitter();

  search = new FormControl('');
  maxDate = new Date();

  displayedColumns: string[] = [
    'check',
    'fullName',
    'reference',
    'type',
    'amount',
    'walletType',
    'dateCreated',
    'status',
  ];

  transactionTypes: { name: string; value: string }[] = [
    {
      name: 'All',
      value: TRANSACTION_STATUS.ALL,
    },
    {
      name: 'Credits',
      value: TRANSACTION_STATUS.CREDIT,
    },
    {
      name: 'Debits',
      value: TRANSACTION_STATUS.DEBIT,
    },
    {
      name: 'Exchanges',
      value: TRANSACTION_STATUS.EXCHANGE,
    },
    {
      name: 'Withdrawals',
      value: TRANSACTION_STATUS.WITHDRAW,
    },
    {
      name: 'Redemptions',
      value: TRANSACTION_STATUS.REDEMPTION,
    },
    {
      name: 'Fees',
      value: TRANSACTION_STATUS.FEE,
    },
  ];

  walletTransactionStatus = [
    {
      name: 'All',
      value: WALLET_TRANSACTION_STATUS.ALL,
    },
    {
      name: 'Initiated',
      value: WALLET_TRANSACTION_STATUS.INITIATED,
    },
    {
      name: 'Processing',
      value: WALLET_TRANSACTION_STATUS.PROCESSING,
    },
    {
      name: 'Pending',
      value: WALLET_TRANSACTION_STATUS.PENDING,
    },
    {
      name: 'Successful',
      value: WALLET_TRANSACTION_STATUS.SUCCESSFUL,
    },
    {
      name: 'Cancelled',
      value: WALLET_TRANSACTION_STATUS.CANCELLED,
    },
    {
      name: 'Failed',
      value: WALLET_TRANSACTION_STATUS.FAILED,
    },
    {
      name: 'Waiting',
      value: WALLET_TRANSACTION_STATUS.WAITING,
    },
    {
      name: 'Rejected',
      value: WALLET_TRANSACTION_STATUS.REJECTED,
    },
  ];

  walletTransactionType = [
    {
      name: 'All',
      value: '',
    },
    {
      name: 'Global',
      value: 'GLOBAL',
    },
    {
      name: 'Local',
      value: 'LOCAL',
    },
  ];

  public filter: Record<string, any> = {};

  formatToCurrency = formatToCurrency;

  searchForm: FormGroup;

  private readonly defaultPageEvent = {
    pageSize: 10,
    pageIndex: 0,
  };

  pageEvent: Partial<PageEvent> = this.defaultPageEvent;

  dataSource;

  componentDestroyed$: Subject<boolean> = new Subject();

  selectedItems = new Map();

  @ViewChild(MatMultiSort, { static: false }) sort: MatMultiSort;

  isSuperAdmin = false;

  merchants: {
    list: MerchantsModel[];
    loading: boolean;
    total: number;
    pageSize: number;
    pageNumber: number;
  } = {
    list: [],
    loading: false,
    total: 0,
    pageSize: 1000,
    pageNumber: 0,
  };

  constructor(
    private consoleRouter: ConsoleRouterService,
    public transactionList: TransactionListStateService,
    public authProfile: AuthProfileStateService,
    public merchantListState: MerchantListStateService
  ) {}

  ngOnInit(): void {
    this.createForm();

    this.listenOnSearchForm();

    this.listenOnState();

    this.listenOnAuthProfile();

    this.listenOnMerchants();
  }

  // ngAfterViewInit(): void {
  // if (!this.userId) {
  //   this.displayedColumns = [
  //     ...this.displayedColumns,
  //     'action'
  //   ];
  // }
  // }

  private createForm(): void {
    this.searchForm = new FormGroup({
      q: new FormControl(''),
      action: new FormControl(''),
      status: new FormControl(''),
      walletType: new FormControl(''),
      merchantId: new FormControl(''),
      from: new FormControl(''),
      to: new FormControl(),
    });
  }

  private listenOnSearchForm(): void {
    this.searchForm.valueChanges
      .pipe(
        filter(Boolean),
        debounceTime(500),
        distinctUntilChanged(),
        tap((formValues) => {
          this.filter = {
            pageSize: this.filter.pageSize || this.pageEvent.pageSize,
            ...extractSearchParams(formValues),
          };

          this.handleQuery();
        })
      )
      .subscribe();
  }

  private listenOnState(): void {
    // this.loading = true;
    this.transactionList.state
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((state: TransactionListState) => {
        this.dataSource = new MatTableDataSource<WalletTxnDetailsModel>(
          state.transactions
        );
        this.dataSource.sort = this.sort;
        this.count = state.count;
        this.loading = state.loading;

        // this.ref.detectChanges();
      });
  }

  listenOnAuthProfile(): void {
    this.authProfile.isSuperAdmin$
      .pipe(
        takeUntil(this.componentDestroyed$),
        filter((isSuperAdmin) => isSuperAdmin)
      )
      .subscribe((isSuperAdmin) => {
        this.isSuperAdmin = isSuperAdmin;

        this.isSuperAdmin
          ? this.merchantListState.find({
              pageSize: this.merchants.pageSize,
              pageNumber: this.merchants.pageNumber,
            })
          : null;
      });
  }

  listenOnMerchants(): void {
    this.merchantListState.state
      .pipe(
        takeUntil(this.componentDestroyed$),
        filter(() => this.isSuperAdmin)
      )
      .subscribe((state: MerchantListState) => {
        this.merchants.loading = state?.loading;
        this.merchants.total = state?.count;
        this.merchants.list = [...this.merchants.list, ...state?.merchants];
      });
  }

  paginate($event: PageEvent): void {
    this.filter.pageSize = $event.pageSize;
    this.filter.pageNumber = $event.pageIndex;

    this.handleQuery();
  }

  // isValidSearch(): boolean {
  //   return Object.values(this.searchForm.value).every(val => val === null || val === '');
  // }

  // onSearchClicked(): void {
  //   if (!this.isValidSearch()) {
  //     return;
  //   }

  //   this.handleQuery();
  // }

  handleQuery(): void {
    this.query.emit(this.filter);
  }

  emit(transaction: WalletTxnsModel): void {
    this.transaction.emit(transaction);
  }

  viewUser(userId: string): void {
    this.consoleRouter.productNavigate(['users', userId]);
  }

  get allSelected(): boolean {
    return this.dataSource.data.every(({ id }) => this.selectedItems.has(id));
  }

  onAllChecked(checked: boolean): void {
    this.dataSource.data.forEach((transaction) => {
      this.updateCheckedSet(checked, transaction);
    });
  }

  onItemChecked(checked: boolean, transaction: WalletTxnDetailsModel): void {
    this.updateCheckedSet(checked, transaction);
  }

  updateCheckedSet(checked: boolean, transaction: WalletTxnDetailsModel): void {
    if (checked) {
      this.selectedItems.set(transaction.id, transaction);
    } else {
      this.selectedItems.delete(transaction.id);
    }
  }

  downloadFile(): void {
    const name = fileNameFormatter(
      'Transaction',
      this.filter.from,
      this.filter.to
    );

    exportAndDownload(name, Array.from(this.selectedItems.values()));
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
